import { Box, Theme, useMediaQuery } from '@mui/material';
import { useMemo } from 'react';

import { ValuingCustomPagination } from '../HBCarousel/CarouselCustomPagination';
import { HBCarousel } from '../HBCarousel/HBCarousel';
import { HBImageWidget } from './HBImageWidget';

export interface HBImageSliderWidgetProps {
  data: {
    metaData?: string;
    imageUrl?: string;
    title?: string;
    name?: string;
    description?: string;
    order: number;
    factor?: 'smallSizeSliderImages' | 'fullSizeSliderImages';
  }[];
  prefixImageUrl: string;
  metaData?: string | null;
  name?: string | null;
}
export const HBImageSliderWidget = (props: HBImageSliderWidgetProps): JSX.Element => {
  const { data, prefixImageUrl, metaData: metaDataProps, name } = props;
  const breakpointsMd = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  const smallImages = useMemo(
    () =>
      data
        ?.filter((img) => img.factor === 'smallSizeSliderImages')
        ?.sort((x, y) => x.order - y.order),
    [],
  );
  const largeImages = useMemo(
    () =>
      data
        ?.filter((img) => img.factor === 'fullSizeSliderImages')
        ?.sort((x, y) => x.order - y.order),
    [],
  );

  const finalData = useMemo(() => {
    if (breakpointsMd) return largeImages;
    return smallImages;
  }, [breakpointsMd]);

  const slideDelay = metaDataProps ? JSON.parse(metaDataProps)?.delayTime : {};
  return (
    <Box
      className={name || ''}
      sx={(theme) => ({
        maxWidth: 1920,
        width: '100vw',
        marginLeft: 'calc(((100% - 100vw) / 2) - 2px)',
        [theme.breakpoints.up(1920)]: {
          marginLeft: 'calc((100% - 1920px)/2)',
        },
        [theme.breakpoints.down('lg')]: {
          marginLeft: 'calc((100% - 100vw)/2)',
        },
        '& .swiper-button-prev, & .swiper-button-next': {
          opacity: 0,
          '&:hover': {
            opacity: '1 !important',
          },
        },
        '& .swiper-button-prev': {
          '&:after': {
            pr: 0.25,
          },
        },
        '& .swiper-button-next': {
          '&:after': {
            pl: 0.25,
          },
        },
        '&:hover': {
          '& .swiper-button-prev': {
            opacity: 0.7,
          },
          '& .swiper-button-next': {
            opacity: 0.7,
          },
        },
        '& .swiper .swiper-pagination-bullet-active': {
          width: 8,
        },
        [theme.breakpoints.only('xs')]: {
          '& .swiper .swiper-pagination-bullets': {
            bottom: '0 !important',
          },
        },
      })}
    >
      <HBCarousel
        pagination={{
          renderBullet(index, className) {
            return ValuingCustomPagination(index, className);
          },
          clickable: true,
        }}
        navigation={breakpointsMd ? true : false}
        delay={slideDelay}
        loop
      >
        {finalData?.map((banner, index) => (
          <HBImageWidget
            key={'banner' + index}
            type={'ADS_SLIDER_DEFAULT'}
            objectFit="cover"
            {...banner}
            imageUrl={banner.imageUrl ? prefixImageUrl + banner.imageUrl : undefined}
            noBorderRadius
          />
        ))}
      </HBCarousel>
    </Box>
  );
};
